//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { httpAction } from '@/api/manage';
import pick from 'lodash.pick';
import moment from 'moment';
export default {
  name: 'MessageIssuedModal',
  data: function data() {
    return {
      title: '操作',
      visible: false,
      model: {},
      labelCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 4
        }
      },
      wrapperCol: {
        xs: {
          span: 24
        },
        sm: {
          span: 20
        }
      },
      confirmLoading: false,
      dates: [],
      form: this.$form.createForm(this),
      validatorRules: {
        cn: {
          rules: [{
            required: true,
            message: '请输入命令编号CN!'
          }]
        },
        flag: {
          rules: [{
            required: true,
            message: '请输入flag!'
          }]
        } // cp: { rules: [{ required: true, message: '请输入报文内容CP!' }] }

      },
      url: {
        add: '/comm/api/messageIssued'
      }
    };
  },
  created: function created() {},
  methods: {
    moment: moment,
    edit: function edit(record) {
      this.dates = [];
      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
    },
    close: function close() {
      this.form.resetFields();
      this.$emit('close');
      this.visible = false;
    },
    handleOk: function handleOk() {
      var _this = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        that.confirmLoading = true;
        var httpurl = '';
        var method = '';

        if (!_this.model.id) {
          httpurl += _this.url.add;
          method = 'post';
        } else {
          httpurl += _this.url.edit;
          method = 'put';
        }

        var formData = Object.assign(_this.model, values);

        _this.$confirm({
          title: '你确定要下发报文操作吗?',
          content: '提示信息',
          onOk: function onOk() {
            that.confirmLoading = true;
            httpAction(httpurl, formData, method).then(function (res) {
              if (res.success) {
                that.$notification.success({
                  message: res.message
                });
                that.$emit('ok');
                that.close();
              } else {
                that.$notification.warning({
                  message: res.message
                });
              }
            }).finally(function () {
              that.confirmLoading = false;
            });
          },
          onCancel: function onCancel() {}
        });
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    }
  }
};